// extracted by mini-css-extract-plugin
module.exports = {"root":"PersonalAreaPage-styles_root__bmuQD","tabContainer":"PersonalAreaPage-styles_tabContainer__35HyK","tabContainerActive":"PersonalAreaPage-styles_tabContainerActive__FxLMK"};